<div class="stsdocs-global-sidenav-container">
    <mat-sidenav-container>
        <mat-sidenav mode="side" opened>
            <button mat-stroked-button [routerLink]="['/']">Web Console</button>
            <button mat-stroked-button [routerLink]="['/clients']">Client Docs</button>
            <button mat-stroked-button [routerLink]="['/products']">Downloads</button>
        </mat-sidenav>
        <mat-sidenav-content>
            <div class="stsdocs-global-body">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>